/** Clamp a finite normalized metric into its closed [0, 1] interval. */
export function clampUnitInterval(value) {
  if (!Number.isFinite(value)) return 0;
  if (value < 0) return 0;
  if (value > 1) return 1;
  return value;
}
